export default __webpack_public_path__ + "static/media/art-commerce.e26eec81.svg";